import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AlertModalService, AlertModalState } from "../../../services/AlertModalService";
import { AlertModalComponent, AlertModalResult } from "../alert-dialog/alert-dialog.component";

@Component({
  selector: 'app-alert-modal-wrapper',
  standalone: true,
  imports: [CommonModule, AlertModalComponent],
  templateUrl: './alert-modal-wrapper.html',
  // Angular 22 : OnPush est le défaut -> l'état du modal (propriété simple mise à jour par
  // souscription) ne déclenchait aucun rendu, le modal ne s'ouvrait jamais.
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AlertModalWrapperComponent {
  modalState: AlertModalState = { isOpen: false, config: null };

  constructor(private alertModalService: AlertModalService) {
    this.alertModalService.modalState$.subscribe(state => {
      this.modalState = state;
    });
  }

  onModalResult(result: AlertModalResult): void {
    this.alertModalService.hideAlert(result);
  }
}
